import React from "react";
import PropTypes from "prop-types";
import styles from "./NotificationOverlay.module.css";
import classNames from "classnames";

/**
 * View component. An overlay that notifies the user when a feed item has been added or deleted.
 */
export function NotificationOverlay({ overlayText, isVisible }) {
  return (
    <div
      className={classNames(styles.overlay, {
        [styles.invisible]: !isVisible,
      })}
    >
      <p>{overlayText}</p>
    </div>
  );
}

NotificationOverlay.propTypes = {
  /**
   * Text of the overlay.
   */
  overlayText: PropTypes.string,
  /**
   * Determines if the overlay is visible.
   */
  isVisible: PropTypes.bool,
};
